var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaperclip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2929 7.36629L8.16621 13.493C7.41565 14.2435 6.39767 14.6652 5.33621 14.6652C4.27475 14.6652 3.25677 14.2435 2.50621 13.493C1.75565 12.7424 1.33398 11.7244 1.33398 10.663C1.33398 9.6015 1.75565 8.58352 2.50621 7.83295L8.63288 1.70629C9.13325 1.20591 9.81191 0.924805 10.5195 0.924805C11.2272 0.924805 11.9058 1.20591 12.4062 1.70629C12.9066 2.20666 13.1877 2.88532 13.1877 3.59295C13.1877 4.30059 12.9066 4.97925 12.4062 5.47962L6.27288 11.6063C6.02269 11.8565 5.68336 11.997 5.32954 11.997C4.97572 11.997 4.6364 11.8565 4.38621 11.6063C4.13602 11.3561 3.99547 11.0168 3.99547 10.663C3.99547 10.3091 4.13602 9.96981 4.38621 9.71962L10.0462 4.06629",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperclip);
export default __webpack_public_path__ + "static/media/paperclip.7c7b7089418b2c8328199e27c21e3946.svg";
export { ForwardRef as ReactComponent };